var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_c('svg',{staticClass:"c-a-icon title-icon"},[_c('use',{attrs:{"href":("/assets/icons/icons.svg#" + _vm.icon),"xlink:href":("/assets/icons/icons.svg#" + _vm.icon)}})]),_vm._v(" "),_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79c1b63d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/atoms/AtomTitle.vue
// module id = 1294
// module chunks = 0